//
//

import { mapActions } from "vuex";
import AQSearch from "@/components/Generics/AQSearch/AQSearch.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQSkeleton from "@/components/Generics/AQSkeleton/AQSkeleton.vue";
import AQList from "@/components/Generics/AQList/AQList.vue";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import AQEmptyState from "@/components/Generics/AQEmptyState/AQEmptyState.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import aurachainAppLogo from "@/assets/images/InternalEntity.svg";
import externalAppLogo from "@/assets/images/ExternalEntity.svg";
import PermissionsModal from "./PermissionsModal.vue";
import AddNewAccessPermissionModal from "./AddNewAccessPermissionModal.vue";
import ExportPanel from "./ExportPanel.vue";

export default {
    name: "TablesList",
    components: {
        AQSearch,
        AQButton,
        AQSkeleton,
        AQList,
        AQEmptySearch,
        AQEmptyState,
        PermissionsModal,
        AQDialog,
        AQInput,
        AddNewAccessPermissionModal,
        ExportPanel
    },
    props: {
        isLegacy: {
            type: Boolean,
            default: false
        },
        filteredList: {
            default: () => [],
            type: Array
        },
        emptyState: {
            default: true,
            type: Boolean
        },
        search: {
            default: "",
            type: String
        },
        skeletonState: {
            default: true,
            type: Boolean
        }
    },
    data() {
        return {
            appLogo: aurachainAppLogo,
            externalLogo: externalAppLogo,
            optionsMore: [{ name: "rename", label: this.$t("globalDataModel.rename") }, { name: "permissions", label: this.$t("globalDataModel.permissions") }],
            hideListBtns: ["edit", "copy"],
            permissionsModalFromList: false,
            renameDialog: false,
            entityName: "",
            entityToBeRenamed: {},
            wrongPatternErr: false,
            emptyName: false,
            duplicatedEntityName: false,
            initialNameValue: "",
            isPermissionList: false,
            itemSelected: { },
            addAccessPermissionsModalList: false,
            alreadyInRoom: false,
            userInTheRoom: "",
            showExportMenu: false,
            exportEntityCode: null,
            exportColumns: [],
            exportMenuTarget: true,
            searchTrigger: false,
            localSearch: this.search
        };
    },
    computed: {
        changedList() {
            // for AQList caption to show, we need to call it "email".......
            return this.filteredList.map(({ name, code }) => ({ name, email: code, code }));
        },
        isError() {
            return this.emptyName || this.wrongPatternErr || this.duplicatedEntityName || this.alreadyInRoom;
        },
        errorLabel() {
            let errorMsg;
            if (this.emptyName) {
                errorMsg = this.$t("globalDataModel.emptyEntityName");
            } else if (this.wrongPatternErr) {
                errorMsg = this.$t("globalDataModel.wrongPatternEntityName");
            } else if (this.duplicatedEntityName) {
                errorMsg = this.$t("globalDataModel.duplicatedEntity");
            } else if (this.alreadyInRoom) {
                errorMsg = this.$t("globalDataModel.alreadyInRoom", { userName: this.userInTheRoom });
            }
            return errorMsg;
        }
    },
    watch: {
        search: {
            handler(newValue) {
                if (this.$route.query && Object.keys(this.$route.query).length && newValue) {
                    this.searchTrigger = true;
                    this.localSearch = newValue;
                }
            }
        },
        showSearch: {
            handler(newVal) {
                this.searchTrigger = newVal;
                setTimeout(() => {
                    this.searchTrigger = false;
                }, 0);
            },
            immediate: true
        }
    },
    created() {
        this.$root.$on("oneAtATime-dataStore-rename", msg => {
            if (this.$oneAtATime.state.$currentEditingUser) {
                this.alreadyInRoom = true;
                this.userInTheRoom = this.$oneAtATime.state.$currentEditingUser;
            } else if (msg === "true") {
                this.renameEntityMth();
            }
        });
    },
    beforeDestroy() {
        this.$root.$off("oneAtATime-dataStore-rename");
    },
    methods: {
        ...mapActions("dataStore", ["renameEntity", "getAttributes"]),
        actionsList({ action, item, index }) {
            if (this.showExportMenu) {
                return;
            }
            if (action === "delete") {
                const payload = {
                    entityCode: item.code,
                    entityName: item.name
                };
                this.$emit("deleteEntity", payload);
            } else if (action === "rename") {
                this.renameDialog = true;
                this.initialNameValue = item.name;
                this.entityName = item.name;
                this.entityToBeRenamed.code = item.code;
            } else if (action === "permissions") {
                this.itemSelected = { ...item };
                this.permissionsModalFromList = true;
            } else if (action === "download") {
                this.exportEntityCode = item.code;
                this.exportMenuTarget = `.q-list .q-item:nth-of-type(${index + 1}) .list-button .download`;
                this.getAttributes(item.code).then(({ data }) => {
                    const columns = [];
                    data.forEach(att => {
                        const column = {
                            code: att.code,
                            name: att.code,
                            label: att.name
                        };
                        if (column.code === "id") {
                            columns.unshift(column);
                        } else if (column.type !== "attachment") {
                            columns.push(column);
                        }
                    });
                    this.exportColumns = columns;
                    this.showExportMenu = true;
                });
            }
        },
        wrnAction(action) {
            if (action === "cancel") {
                this.emptyName = false;
                this.duplicatedEntityName = false;
                this.wrongPatternErr = false;
                this.renameDialog = false;
                this.alreadyInRoom = false;
                this.$oneAtATime.destroyCurrentRoom();
            } else if (action === "ok") {
                this.$oneAtATime.createRoom("dataStore", this.entityToBeRenamed.code, "rename");
            }
        },
        renameEntityMth() {
            if (!this.emptyName && !this.duplicatedEntityName && !this.wrongPatternErr && !this.alreadyInRoom) {
                if (this.initialNameValue === this.entityName) {
                    this.renameDialog = false;
                    this.$root.$off("oneAtATime-dataStore-rename");
                    this.$oneAtATime.destroyCurrentRoom();
                } else {
                    const payload = {
                        entityCode: this.entityToBeRenamed.code,
                        name: this.entityName
                    };
                    this.renameEntity(payload).then(data => {
                        if (data && data.data) {
                            sessionStorage.setItem("currentDataStoreUser", true);
                            this.renameDialog = false;
                            this.$emit("refreshEntityList", { ev: "renamed", name: payload.name });
                            this.$toast.showNotify({
                                type: "success",
                                message: this.$t("globalDataModel.renameEntityToast", { entityName: this.initialNameValue }),
                                timeout: 2000
                            });
                        }
                    });
                    this.$oneAtATime.destroyCurrentRoom();
                }
            } else {
                this.renameDialog = true;
            }
        },
        checkName() {
            // eslint-disable-next-line
            const validatePattern = new RegExp(/^[ a-zA-Z0-9_\/\n/-]{1,60}$/);
            this.wrongPattern = !validatePattern.test(this.entityName);
            this.emptyName = !this.entityName;
            this.wrongPatternErr = this.wrongPattern;
            const foundEntityName = this.filteredList.find(element => element.name === this.entityName);
            if (foundEntityName && (this.initialNameValue !== this.entityName)) {
                this.duplicatedEntityName = true;
            } else {
                this.duplicatedEntityName = false;
            }
        },
        clickEntity(event) {
            if (!this.showExportMenu) {
                this.$emit("clickEntity", event.code);
            }
        },
        closeExportPanel(ev) {
            if (ev) {
                this.showExportMenu = ev;
            } else {
                setTimeout(() => {
                    this.showExportMenu = ev;
                }, 200);
            }
        }
    }
};

